import React from "react";

const COLOR_VARIANT_MAPPING = {
    orange: "orange"
};

const HoverTextBox = (props) => {
    const {text, colorVariant} = props;

    return (
        <div
            className={
                'hoverTextBox'
                + ` ${colorVariant ? COLOR_VARIANT_MAPPING[colorVariant] : ""}`
            }
        >
            <div className="">
                {text}
            </div>
        </div>
    )
};

export default HoverTextBox;